import React, { useState, useEffect } from "react";
import SchoolHeader from "./components/SchoolReports/SchoolHeader";
import DoubleProgressBar from "./components/SchoolReports/DoubleProgressBar";
import target from "../accerts/svg/Schoolreports/mingcute.svg";
import GradeWiseParticipationChart from "./components/SchoolReports/GradeWiseParticipationChart";
import GradeWiseDetails from "./components/SchoolReports/GradeWiseDetails";
import Summary from "./components/SchoolReports/Summary";
import Footer from "./components/Footer/Footer";
import loaderGif from "../accerts/gifs/LoaderGif.gif";
import { useParams } from "react-router-dom";
import { CONFIG_VARS } from "./constants/configaration";
import { ReportProvider } from "./constants/SchoolReportContext";
import { DynamicToolTip } from "./components/DynamicToolTip/DynamicToolTip";
import i from "../accerts/svg/emsat/i.svg";
const SchoolReports = () => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { schoolId, eventId } = useParams();

  const fetchReportData = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${CONFIG_VARS.baseUrl}/report_generation/school-report`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
            "product-id": "100",
            "tenant-id": "99999",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            school_id: schoolId,
            event_id: eventId,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch report data");
      }

      const data = await response.json();
      if (!data || Object.keys(data).length === 0) {
        throw new Error("Report data is empty");
      }

      setReportData(data?.school_report_data);
      setError(null);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReportData();
  }, [schoolId, eventId]);

  const handleRetry = () => {
    setError(null);
    fetchReportData();
  };

  return (
    <div className="Rep_main_cont">
      <SchoolHeader data={reportData?.metadata} />

      {/* Content Area - Shows either loader, error, or main content */}
      <div className="SB_main_Cont">
        {loading ? (
          <div className="Loader">
            <img src={loaderGif} alt="loading" />
            <h4>Wait we are preparing your reports....</h4>
          </div>
        ) : error || !reportData ? (
          <div className="Loader">
            <p>{error}</p>
            <button className="RefetchBtn" onClick={handleRetry}>
              Retry
            </button>
          </div>
        ) : (
          <ReportProvider reportData={reportData}>
            <>
              <h3 className="Rep_sub-head">Summary</h3>
              <Summary data={reportData?.summary} />

              <h3 className="Rep_sub-head">
                Participation Details{" "}
                <DynamicToolTip
                  content={`This section shows that ${
                    reportData.participation_details[0].total_participation.split(
                      "/"
                    )[0]
                  } students attempted the test, out of ${
                    reportData.participation_details[0].total_participation.split(
                      "/"
                    )[1]
                  } students registered for this event.`}
                >
                  <span>
                    {" "}
                    <img className="EMRe_info" src={i} alt="i" />
                  </span>
                </DynamicToolTip>
              </h3>
              <div className="SB_Rep_card_cont">
                <div
                  className="SB_Rep_card"
                  style={{ flexDirection: "column", position: "relative" }}
                >
                  <img src={target} className="SR_targetimg" alt="target" />
                  <div>
                    <div className="SB_card_title">
                      <span>
                        <div className="SB_buedot1"></div>
                      </span>
                      Total Participation
                    </div>
                    <h4 className="SB_tp_Students">
                      {reportData?.participation_details[0]
                        ?.total_participation ? (
                        <>
                          {
                            reportData.participation_details[0].total_participation.split(
                              "/"
                            )[0]
                          }
                          <span>
                            /
                            {
                              reportData.participation_details[0].total_participation.split(
                                "/"
                              )[1]
                            }
                          </span>
                        </>
                      ) : (
                        <span>0</span>
                      )}
                    </h4>
                  </div>
                  <DoubleProgressBar
                    participation={
                      reportData?.participation_details[0]
                        ?.overall_participation_percent
                    }
                    average={
                      reportData?.participation_details[0]
                        ?.other_schools_avg_percent
                    }
                  />
                </div>
                <div className="SB_Rep_card">
                  <GradeWiseParticipationChart
                    data={
                      reportData?.participation_details[0]
                        ?.gradewise_participation
                    }
                  />
                </div>
              </div>

              <h3 className="Rep_sub-head">
                Gradewise Details{" "}
                <DynamicToolTip
                  content={`This section provides a detailed performance breakdown for each grade across different subjects.`}
                >
                  <span>
                    {" "}
                    <img className="EMRe_info" src={i} alt="i" />
                  </span>
                </DynamicToolTip>
              </h3>
              <GradeWiseDetails data={reportData?.gradewise_data} />
            </>
          </ReportProvider>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default SchoolReports;
